import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// TW merge doesn't know about our tractie classes, so merging .e.g text-content-default and text-xl incorrectly removes the latest class. We have to tell twMerge about our custom class names.
const customTwMerge = extendTailwindMerge({
    override: {
        classGroups: {
            "font-size": ["text-xs", "text-s", "text-m", "text-l", "text-xl", "text-xxl", "text-xxxl"],
            "text-color": [
                "text-chart-category-1",
                "text-chart-category-2",
                "text-chart-category-3",
                "text-chart-category-4",
                "text-chart-category-5",
                "text-chart-category-6",
                "text-chart-category-7",
                "text-chart-category-8",
                "text-chart-error",
                "text-chart-neutral",
                "text-chart-success",
                "text-chart-warning",
                "text-content-default",
                "text-content-default-inverse",
                "text-content-destructive-default",
                "text-content-destructive-hover",
                "text-content-destructive-pressed",
                "text-content-emphasis",
                "text-content-error",
                "text-content-error-inverse",
                "text-content-info",
                "text-content-interactive-default",
                "text-content-interactive-default-inverse",
                "text-content-interactive-hover",
                "text-content-interactive-pressed",
                "text-content-logo",
                "text-content-on-accent-subtle",
                "text-content-on-accent-yellow-default",
                "text-content-placeholder",
                "text-content-selected",
                "text-content-subtle",
                "text-content-success",
                "text-content-warning",
                "text-content-warning-inverse",
            ],
        },
    },
});

/**
 * Merge class names with Tailwind CSS
 * @param inputs Class values to merge
 * @returns Merged class string
 */
export function cn(...inputs: ClassValue[]) {
    return customTwMerge(clsx(inputs));
}
